import React, { useState } from 'react';
import { ExternalLink, Github } from 'lucide-react';
import Header from '../components/Header';
import BuiltBy from '../components/BuiltBy';
import { portfolioData } from '../data/portfolio';

const ProjectsPage = () => {
  const [filter, setFilter] = useState('all');
  const { projects } = portfolioData;

  const filteredProjects = filter === 'all' 
    ? projects 
    : projects.filter(project => project.category === filter);

  return (
    <div className="min-h-screen bg-[#0a0a0a] text-white">
      <Header />
      
      <main className="pt-32 pb-20 px-6">
        <div className="max-w-6xl mx-auto">
          {/* Page Header */}
          <div className="mb-16 text-center">
            <h1 className="text-5xl md:text-6xl font-bold mb-6">All Projects</h1>
            <div className="w-20 h-1 bg-[#00b4d8] mx-auto mb-6"></div>
            {/* <p className="text-lg text-[#a0a0a0] max-w-2xl mx-auto">
              A comprehensive collection of my data analytics and program management work
            </p> */}
          </div>

          {/* Filter Buttons
          <div className="flex flex-wrap justify-center gap-3 mb-12">
            <button
              onClick={() => setFilter('all')}
              className={`px-6 py-3 rounded-full font-medium transition-all duration-300 ${
                filter === 'all'
                  ? 'bg-[#00b4d8] text-white'
                  : 'bg-[#151515] text-[#a0a0a0] border border-white/10 hover:border-[#00b4d8] hover:text-white'
              }`}
            >
              All Projects ({projects.length})
            </button>
            <button
              onClick={() => setFilter('data')}
              className={`px-6 py-3 rounded-full font-medium transition-all duration-300 ${
                filter === 'data'
                  ? 'bg-[#00b4d8] text-white'
                  : 'bg-[#151515] text-[#a0a0a0] border border-white/10 hover:border-[#00b4d8] hover:text-white'
              }`}
            >
              Data Analytics ({projects.filter(p => p.category === 'data').length})
            </button>
            <button
              onClick={() => setFilter('program')}
              className={`px-6 py-3 rounded-full font-medium transition-all duration-300 ${
                filter === 'program'
                  ? 'bg-[#00b4d8] text-white'
                  : 'bg-[#151515] text-[#a0a0a0] border border-white/10 hover:border-[#00b4d8] hover:text-white'
              }`}
            >
              Program Management ({projects.filter(p => p.category === 'program').length})
            </button>
          </div> */}

          {/* Projects Grid */}
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {filteredProjects.map((project, index) => (
              <div
                key={index}
                className="bg-[#151515] border border-white/10 rounded-lg overflow-hidden hover:border-[#00b4d8] transition-all duration-300 group"
              >
                <div className="h-20">
                  <img
                    src={project.imageUrl}
                    alt={project.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                </div>

                <div className="p-5">
                  <div className="flex items-center justify-end gap-3 mb-3">
                    {/* <span className="text-xs font-semibold text-[#00b4d8] uppercase tracking-wider">
                      {project.category === 'data' ? 'Data Analytics' : 'Program Management'}
                    </span> */}
                    {/* <ExternalLink size={16} className="text-[#666666] group-hover:text-[#00b4d8] transition-colors" /> */}
                    {project.githubLink && (
                    <a
                      href={project.githubLink}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-[#666666] hover:text-[#00b4d8] transition-colors"
                    >
                      <Github size={16} />
                    </a>
                    )}

                    {project.liveLink && (
                      <a
                        href={project.liveLink}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-[#666666] hover:text-[#00b4d8] transition-colors"
                      >
                        <ExternalLink size={16} />
                      </a>
                    )}
                  </div>

                  <h3 className="text-lg font-semibold mb-2 group-hover:text-[#00b4d8] transition-colors line-clamp-2">
                    {project.title}
                  </h3>

                  <p className="text-sm text-[#a0a0a0] mb-4 leading-relaxed line-clamp-3">
                    {project.description}
                  </p>

                  <div className="flex flex-wrap gap-2 mb-4">
                    {project.technologies.slice(0, 3).map((tech, idx) => (
                      <span
                        key={idx}
                        className="text-xs bg-[#0a0a0a] text-[#a0a0a0] px-2 py-1 rounded-full border border-white/10"
                      >
                        {tech}
                      </span>
                    ))}
                  </div>

                  {/* <div className="pt-3 border-t border-white/10">
                    <p className="text-xs text-[#00b4d8] font-medium">
                      {project.impact}
                    </p>
                  </div> */}
                </div>
              </div>
            ))}
          </div>
        </div>
      </main>

      <BuiltBy />
    </div>
  );
};

export default ProjectsPage;
